import { CheckCircle2, Lock, XCircle } from 'lucide-react';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../../Models/User';
import datas from "../../../Assets/data.json";
import env from 'react-dotenv';
import { Crypter } from '../../../Functions/Security/Crypter';
import Hash from '../../../Functions/Security/Hash';
import { FormSection, FormActions, useAlert, Spin, Input, Textarea, Button } from '../../ui';


export interface ConfirmationDialogRawProps {
    classes: Record<'paper', string>;
    id: string;
    keepMounted: boolean;
    value: string;
    open: boolean;
    onClose: (value?: string) => void;
}

export interface Ticket {
    numeroFile: string,
    guichet: string,
    agence: String
}

const FormBlockDeblockuser = (props: { user: any, handleFunction: any }) => {

    // USER TOKEN
    const authHeader = useAuthHeader()
    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert()

    const { register, handleSubmit, setValue, reset } = useForm()
    const [fichier, setFicher] = useState<File>()
    const [isOk, setIsOk] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)


    const onSubmit = async (data: any) => {

        setLoading(true)

        data.Password = Hash(data.Password)

        data = { ...data, CodeSubsciber: user.CodeAbonne, CreatedBy: user.CodeU }
        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + (props.user.Statut == 1 ? datas.API_LINKs.DesactivateFiliale : datas.API_LINKs.ActivateFiliales),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
            },
            data: Crypter.encrypt(JSON.stringify(data))
        };

        axios.request(config)
            .then((response) => {
                setLoading(false)
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    //localStorage.setItem("loadQmGuichet", "1")
                    alert.success(res.Message)
                    reset()
                    props.handleFunction()
                } else {
                    alert.warning(res.Message)
                }
            })
            .catch((error) => {
                setLoading(false)
                alert.error(error.message)
            })

    }

    const [CodeFiliale, setCodeFiliale] = React.useState("");


    return (
        <>
            <Spin spinning={loading}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormSection title="Confirmation" subtitle={`Saisissez le code pour confirmer le ${props.user.Statut == 1 ? 'blockage' : 'déblockage'}`}>
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("IdRow")}
                            required
                            type='text'
                            helperText='Renseigner le Code de la filiale pour confirmer.'
                            label={'Code Entité'}
                            placeholder={"Entrez le code de l'entité"}
                            onChange={(e) => { setCodeFiliale(e.target.value) }}
                        />
                        <div className="flex items-center gap-2">
                            {props.user.CodeFiliale == CodeFiliale
                                ? <CheckCircle2 size={18} className="text-[var(--eb-primary)]" />
                                : <XCircle size={18} className="text-red-500" />}
                            <span className="text-xs text-[var(--eb-text-muted)]">
                                {props.user.CodeFiliale == CodeFiliale ? 'Code confirmé' : 'Le code ne correspond pas'}
                            </span>
                        </div>
                    </FormSection>

                    <FormSection title="Motif & Sécurité" subtitle="Raison de l'action et mot de passe">
                        <Textarea
                            onKeyUp={() => setIsOk(false)}
                            {...register("Reason")}
                            required
                            rows={4}
                            label={'Motif du ' + (props.user.Statut == 1 ? 'blockage' : "déblockage")}
                            placeholder={"Entrez le motif du " + (props.user.Statut == 1 ? 'blockage' : "déblockage") + " de l'utilisateur"} />
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("Password")}
                            required
                            type='password'
                            label={'Mot de passe'}
                            placeholder={"Entrez votre mot de passe"} />
                    </FormSection>

                    <FormActions>
                        <Button disabled={props.user.CodeFiliale != CodeFiliale} variant='secondary' type='submit' startIcon={<Lock size={16} />}>
                            {props.user.Statut == 1 ? 'Bloquer' : 'Débloquer'}
                        </Button>
                    </FormActions>
                </form>
            </Spin>
        </>
    );
};

export default FormBlockDeblockuser;
